import React from 'react';
import PieChart from '../../components/PieChart/PieChart';
import Tile from '../../components/Tile/Tile';
import Headline from '../../components/Headline/Headline';
import './DashboardView.css';
import { useService } from '../../context/ServiceProvider';
import MissingServiceFallback from '../../components/MissingServiceFallback/MissingServiceFallback';

const DashboardView = () => {
  const { currentService } = useService()

  if (!currentService) {
    return <MissingServiceFallback/>;
  }
  
  return (
    <div className="dashboard-container">
      <Headline
        title={`${currentService?.displayName} - Dashboard`}
        subtitle=""
      />

      <div className="section">
        <div className="section-title">Charts</div>
        <div className="charts-container">
          {currentService?.chartsConfig.map((chart, idx) => (
            <div className="chart-card" key={idx}>
              <PieChart {...chart} />
            </div>
          ))}
        </div>
      </div>

       <div className="section">
        <div className="section-title">Overview</div>
        <div className="tiles-container">
          {currentService?.tilesConfig.map((tile, idx) => (
            <Tile key={idx} {...tile} type="Overview" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardView;
